export default __webpack_public_path__ + "static/media/welcome.dd03cab5.jpg";